import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {AppState} from '../core.module';
import * as RouterActions from '../router/store/router.actions';
import * as ChatbotSelectors from '../../features/chatbot/store/chatbot.selectors';

@Injectable()
export class ScoringGuard implements CanActivate {
    ended: boolean;

    constructor (
        private store: Store<AppState>
    ) { }

    canActivate() {
        this.store.pipe(select(ChatbotSelectors.chatEnded)).subscribe(res => this.ended = res);
        if (!this.ended) {
            this.store.dispatch(RouterActions.go({path: ['intro']}));
            return false;
        } else {
            return true;
        }
    }

}
